<template>
  <div class="panel">
    <div
      v-if="title"
      class="panel__heading"
    >
      <h3 class="panel__title">{{ title }}</h3>
    </div>

    <div
      v-if="$slots.default"
      class="panel__body">
      <slot/>
    </div>

    <div
      v-if="$slots.footer"
      class="panel__footer"
    >
      <slot name="footer"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'GcPanel',

    props: {
      title: {
        default: false
      },
    },
  }
</script>

<style>
  .balance-checker .panel {
    color: #55595c;
    border: 1px #e1e1e1 solid;
    font-family: "Helvetica Neue", Arial, -apple-system, system-ui, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, sans-serif;
  }

  .balance-checker .panel__heading {
    padding: 1.25rem;
  }

  .balance-checker .panel__body,
  .balance-checker .panel__footer {
    padding: 0 1.25rem 1.25rem;
  }

  .balance-checker .panel__title {
    margin: 0;
    color: #252525;
    font-size: 1.375rem;
    font-weight: normal;
  }
</style>
